/** Refactor routing ok  */
//TODO handle follawed as query param

import { RouteName } from "../RouteNames";

export const homeRoutes = {
  name: RouteName.Home,
  path: "home",
  component: () => import("@follaw-fr/views/HomeView.vue"),
  children: [
    {
      name: RouteName.HomeFollawed,
      path: "follawed",
      component: () => import("@follaw-fr/views/HomeView.vue"),
    },
  ],
};
